import { accountService } from "../../api/services/account-service";
import { handleApi } from "./common";
import { IUserLoginInfo } from "../../api/entities/account";

export enum UsersActionType {
  BlockUser = "USERS_BLOCK",
  FetchDetail = "USERS_FETCH_DETAIL",
  FetchUserPolicies = "USERS_FETCH_POLICIES",
  FetchCurrentUser = "USERS_FETCH_CURRENT",
  SessionExpired = "USERS_SESSION_EXPIRED",
  UserLoggedIn = "USERS_LOGGED_IN"
}

export const USER_ENTITY_NAME = "users";

class UsersActions {
  userLoggedInAction(loginInfo: IUserLoginInfo) {
    return {
      type: UsersActionType.UserLoggedIn as typeof UsersActionType.UserLoggedIn,
      loginInfo,
    };
  }
  currentUserAction(user: IUserLoginInfo) {
    return {
      type: UsersActionType.FetchCurrentUser as typeof UsersActionType.FetchCurrentUser,
      user,
    };
  }
  logoutCurrentUserAction() {
    return {
      type: UsersActionType.SessionExpired as typeof UsersActionType.SessionExpired,
    };
  }
}

export const usersActions = new UsersActions();

export type UsersAction =
  ReturnType<typeof usersActions.currentUserAction>
  | ReturnType<typeof usersActions.userLoggedInAction>
  | ReturnType<typeof usersActions.logoutCurrentUserAction>
;

class UsersThunkActions {

  getCurrentUser() {
    return (dispatch) => {
      handleApi(accountService
        .getCurrentUser()
        .then((user) => {
          dispatch(usersActions.currentUserAction(user));
        }), true);
    };
  }
}

export const usersThunkActions = new UsersThunkActions();
